var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.414 9L17.563 1.85098C17.7505 1.66346 17.8558 1.40915 17.8558 1.14398C17.8558 0.878818 17.7505 0.624509 17.563 0.436981C17.3755 0.24951 17.1212 0.144196 16.856 0.144196C16.5909 0.144196 16.3366 0.24951 16.149 0.436981L9.00005 7.586L1.85205 0.436981C1.66452 0.24951 1.41021 0.144196 1.14505 0.144196C0.879886 0.144196 0.625577 0.24951 0.438049 0.436981C0.250578 0.624509 0.145264 0.878818 0.145264 1.14398C0.145264 1.40915 0.250578 1.66346 0.438049 1.85098L7.58604 9L0.438049 16.149C0.250578 16.3365 0.145264 16.5908 0.145264 16.856C0.145264 17.1212 0.250578 17.3755 0.438049 17.563C0.625542 17.7505 0.879855 17.8559 1.14505 17.856C1.41024 17.8559 1.66456 17.7505 1.85205 17.563L9.00005 10.414L16.149 17.563C16.3365 17.7505 16.5909 17.8559 16.856 17.856C17.1212 17.8559 17.3756 17.7505 17.563 17.563C17.7505 17.3755 17.8558 17.1212 17.8558 16.856C17.8558 16.5908 17.7505 16.3365 17.563 16.149L10.414 9Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.a7d8eba6c7bbfb7618f76f3069b86bd2.svg";
export { ForwardRef as ReactComponent };